<template>
  <div>
    <!-- フォーム部分 -->
    <TextForm
      :text="text"
      :inputmode="inputmode"
      :placeholder="placeholder"
      :isBackButton="false"
      :maxlength="maxlength"
      :inputClass="formColorClass"
      :isDisabled="isDisabled"
      @input-text="$emit('input-text', $event)"
      @focus="$emit('focus', $event)"
      @blur="validateConvertedNumber()"
    />
    <!-- エラーメッセージ部分 -->
    <div
      v-show="isErrorFlg"
      class="mt-2 text-left text-danger300 text-W2 leading-[13px]"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import TextForm from '@/components/TextForm.vue'
import {useVuelidate} from '@vuelidate/core'
import {required} from '@vuelidate/validators'
import {
  tel,
  email,
  birthDay,
  claimReceiptNumber,
} from '@/utils/customValidationRulesUtil.js'
import Util from '@/mixins/util.js'

const TextFormWithValidation = {
  name: 'TextFormWithValidation',
  mixins: [Util],
  components: {TextForm},
  setup() {
    return {v$: useVuelidate()}
  },
  props: {
    // 最大文字数
    maxlength: {
      type: String,
      default: '-1',
    },
    // 入力テキスト
    text: {
      type: String,
      require: true,
    },
    // input要素で表示するキーボードの指定
    inputmode: {
      type: String,
      default: 'text',
    },
    // プレースホルダーのテキスト
    placeholder: {
      type: String,
      default: '入力',
    },
    // エラー時のテキスト
    errorMessage: {
      type: String,
      default: '',
    },
    // バリデーションの種類
    validationType: {
      type: Array,
      require: true,
    },
    // フォームに付与するクラス
    inputClass: {
      type: String,
      default: '',
    },
    // テキストコンポーネントの操作可否状態
    isDisabled: {
      type: Boolean,
      require: false,
      default: false,
    },
    // 初期表示時にバリデーションを行うか否か
    isFirstLoadValidation: {
      type: Boolean,
      default: false,
    },
  },
  /**
   * バリデーションルールの付与
   */
  validations() {
    return {
      text: this.validationList(),
    }
  },
  emits: ['input-text', 'focus', 'blur'],
  data() {
    return {
      isErrorFlg: false,
    }
  },
  computed: {
    /**
     * フォームに付与するクラスの切り替え（エラー時 : デフォルト時）
     */
    formColorClass() {
      const errorClass = '!border-danger300 bg-danger100'
      return this.isErrorFlg ? errorClass : this.inputClass
    },
    /**
     * 入力文字がバリデーションエラーであるかどうか
     */
    isInvalid: {
      get() {
        return this.v$.text.$invalid
      },
    },
  },
  async mounted() {
    if (this.isFirstLoadValidation) {
      await this.validateConvertedNumber()
    }
  },
  methods: {
    /**
     * 付与するバリデーションを設定し返却する
     */
    validationList() {
      let validation = {}

      // 必須チェック付与
      if (this.validationType.includes('required')) {
        validation.required = required
      }
      // メールアドレスチェック付与
      if (this.validationType.includes('email')) {
        validation.email = email
      }
      // 電話番号チェック付与
      if (this.validationType.includes('tel')) {
        validation.tel = tel
      }
      // 誕生日チェック付与
      if (this.validationType.includes('birthday')) {
        validation.birthDay = birthDay
      }
      // 受付番号チェック付与
      if (this.validationType.includes('claimReceiptNumber')) {
        validation.claimReceiptNumber = claimReceiptNumber
      }
      return validation
    },
    /**
     * フォーカスアウト時、全角数値を半角数値に変換してバリデーションを行う処理
     */
    async validateConvertedNumber() {
      // 半角数値に修正
      const parsedVal = this.getConvertedHankakuNumber(this.text)
      // 親に修正を通知
      this.$emit('input-text', parsedVal)
      this.$emit('blur', parsedVal)

      // バリデーション結果取得
      const validationResult = await this.v$.text.$validate()
      // エラーがなければtrueが返ってくるので、falseをエラーフラグに詰める
      this.isErrorFlg = !validationResult
    },
  },
}
export default TextFormWithValidation
</script>
<style scoped></style>
